/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Weekend_HintInputs */

const en_us2_achievement_weekend_hint = /** @type {(inputs: Achievement_Weekend_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 workouts on a Saturday or Sunday`)
};

const pt_br2_achievement_weekend_hint = /** @type {(inputs: Achievement_Weekend_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 treinos em sábados ou domingos`)
};

const es_419_achievement_weekend_hint = /** @type {(inputs: Achievement_Weekend_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 entrenamientos en sábado o domingo`)
};

const pt_pt2_achievement_weekend_hint = /** @type {(inputs: Achievement_Weekend_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 treinos ao sábado ou ao domingo`)
};

const fr_fr2_achievement_weekend_hint = /** @type {(inputs: Achievement_Weekend_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 séances un samedi ou un dimanche`)
};

const de_de2_achievement_weekend_hint = /** @type {(inputs: Achievement_Weekend_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 Trainings an einem Samstag oder Sonntag`)
};

const it_it2_achievement_weekend_hint = /** @type {(inputs: Achievement_Weekend_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 allenamenti di sabato o domenica`)
};

/**
* | output |
* | --- |
* | "4 workouts on a Saturday or Sunday" |
*
* @param {Achievement_Weekend_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_weekend_hint = /** @type {((inputs?: Achievement_Weekend_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Weekend_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_weekend_hint(inputs)
	if (locale === "es-419") return es_419_achievement_weekend_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_weekend_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_weekend_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_weekend_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_weekend_hint(inputs)
	return en_us2_achievement_weekend_hint(inputs)
});
export { achievement_weekend_hint as "achievement.weekend_hint" }